import type {
  AttachCallOffAttachmentMutationOptions,
  AttachCallOffAttachmentMutationVariables,
} from './types';

import { useMutation } from '@tanstack/react-query';

import { attachCallOffAttachment } from './attachCallOffAttachment';

/**
 * Custom hook for confirming a staged file upload and permanently attaching it to a call-off.
 *
 * @param options - Additional options for the mutation.
 * @returns An object containing the mutation function and related properties.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Call-Off/operation/attach_attachment_calloffs__calloff_id__attachments_put
 */
export const useMutationAttachCallOffAttachment = (
  options?: AttachCallOffAttachmentMutationOptions,
) =>
  useMutation({
    mutationFn: async ({
      callOffId,
      payload,
    }: AttachCallOffAttachmentMutationVariables) =>
      attachCallOffAttachment(callOffId, payload),
    ...options,
  });
